import { render } from "./register-3.vue?vue&type=template&id=8b6ce3ea"
import script from "./register-3.vue?vue&type=script&lang=js"
export * from "./register-3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__